export default __webpack_public_path__ + "img/location-forest.be4c613b.svg";